// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1mny5","colBig":"styles_colBig__2VW5c","colSmall":"styles_colSmall__-X_v_","shopifyNameWrapper":"styles_shopifyNameWrapper__2mnr1"};